import { Injectable } from '@angular/core';
import { BaseService } from '../core/components/base.service';
import { Http, Response, RequestOptions, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { RequestUtil } from '../util/request.util';
import { SessionUtil } from '../util/session.util';
import {MessageService} from 'primeng/components/common/messageservice';
@Injectable()
export class MenusService extends BaseService<any>{

  private static MENU_RESOURCE: string = "/menus";

  constructor(protected http: Http,protected messageService: MessageService) {
    super(http,messageService);
  }

  public getMenus(onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON,true);
    let params: URLSearchParams = RequestUtil.createURLSearchParams();
    let options = new RequestOptions({ headers: headers });
    this.get(BaseService.URL_BASE + MenusService.MENU_RESOURCE+"/"+SessionUtil.getUser().user_id, params, options, onSuccess);
  }

}



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/services/menus.service.ts